import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconGeoObjAmplS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.36388 2.03214C3.57449 2.23945 2.98471 3.08483 2.37329 4.88535C2.10574 5.67326 1.98733 6.09084 2.00148 6.19642C2.04494 6.52047 2.37688 6.70787 2.66247 6.56961C2.83262 6.48726 2.87128 6.41424 3.04899 5.83957C3.58739 4.09852 4.05946 3.18004 4.52073 2.97599C4.98051 2.77262 5.63495 3.47189 6.27044 4.84561C6.65042 5.66695 6.80352 6.06609 7.91835 9.14181C8.47606 10.6805 8.6366 11.0807 8.96117 11.7415C9.34267 12.5182 9.67545 13.0086 10.0887 13.4032C10.5891 13.881 11.0932 14.0731 11.5898 13.9752C12.499 13.7961 13.1354 12.7859 13.8764 10.3458C14.0254 9.85499 14.0298 9.77984 13.9194 9.60217C13.764 9.35198 13.4179 9.31396 13.2079 9.52399C13.1354 9.5965 13.1051 9.6558 13.0559 9.82182C12.9133 10.3033 12.5869 11.2711 12.4718 11.5538C12.0449 12.6019 11.6548 13.1015 11.2952 13.0609C10.8699 13.013 10.3754 12.4447 9.85494 11.4057C9.49457 10.6863 9.14952 9.82086 8.4925 7.98837C7.65549 5.65396 7.36177 4.91631 6.91009 4.01466C6.59255 3.38079 6.33042 2.99499 5.98352 2.65098C5.77769 2.44688 5.46717 2.22205 5.27149 2.13549C4.97722 2.00533 4.62059 1.96473 4.36388 2.03214ZM2.30175 7.56327C2.25774 7.57929 2.18268 7.63096 2.13497 7.67811C1.93001 7.88064 1.96277 8.21665 2.2041 8.38714L2.30369 8.45751L4.23243 8.46377L6.16116 8.47003L6.26531 8.41505C6.32256 8.38482 6.4011 8.31513 6.4398 8.26017C6.50137 8.17277 6.51017 8.14021 6.51017 8.0001C6.51017 7.85992 6.5014 7.82751 6.4398 7.74032C6.4011 7.68552 6.32721 7.61865 6.2756 7.5917C6.1829 7.54328 6.159 7.54265 4.28178 7.5384C2.81759 7.53509 2.36342 7.54079 2.30175 7.56327ZM9.78349 7.56158C9.66569 7.59913 9.53839 7.7372 9.50213 7.86675C9.44358 8.07582 9.5246 8.28996 9.70458 8.40185L9.79412 8.45751H11.7449L13.6956 8.45751L13.7953 8.38714C14.0854 8.1822 14.0606 7.75911 13.7489 7.59627L13.6239 7.53097L11.7442 7.53336C10.4473 7.53502 9.83936 7.54375 9.78349 7.56158Z"
        fill="var(--color-typo-primary)"
      />
    </svg>
  )
}

export const IconGeoObjAmpl = createIcon({
  l: IconGeoObjAmplS,
  m: IconGeoObjAmplS,
  s: IconGeoObjAmplS,
  xs: IconGeoObjAmplS,
  name: 'IconGeoObjAmpl',
})
